export enum FilterType {
  location = "location",
  group = "group",
  gender = "gender",
  age = "age",
  sdg = "sdg",
  topic = "topic",
}

export enum TeamStakeholderType {
  customers = "customers",
  citizens = "citizens",
  employees = "employees",
  students = "students",
  fans = "fans",
  general = "general",
}

export enum DashboardActivityType {
  episode = "episode",
  action = "action",
  quiz = "quiz",
  mobility = "mobility",
  footprint = "footprint",
  news = "news",
  survey = "survey",
  wellness = "wellness",
}

export enum DashboardMissionType {
  episode = "episode",
  action = "action",
  quiz = "quiz",
  mobility = "mobility",
  streak = "streak",
  activity = "activity",
  wellness = "wellness",
  exp = "exp",
}

export enum TagType {
  category = "category",
  sdg = "sdg",
}

export const enum SlideType {
  TitleSlide = "TitleSlide",
  FullTextSlide = "FullTextSlide",
  TextImageSlide = "TextImageSlide",
  PortraitSlide = "PortraitSlide",
  EmbedSlide = "EmbedSlide",
  FullImageSlide = "FullImageSlide",
  QuoteSlide = "QuoteSlide",
}
